module.exports = __webpack_public_path__ + "static/012-9d7dde0396005b4fb6ea8796152b1ee1.png";